interface MonetaryTotalPayload {
  amount: number;
  taxCost?: number;
}

export function calculateOrderTotal(payload: MonetaryTotalPayload): number {
  const { amount, taxCost = 0 } = payload;
  return amount + taxCost;
}

export function getPurchaseOrderTotal(payload: {
  buyPrice: number;
  taxCost?: number;
  totalAmount?: number;
}): number {
  const { buyPrice, taxCost, totalAmount } = payload;
  return totalAmount ?? calculateOrderTotal({ amount: buyPrice, taxCost });
}

export function getSalesOrderTotal(payload: {
  revenue: number;
  taxCost?: number;
  totalAmount?: number;
}): number {
  const { revenue, taxCost, totalAmount } = payload;
  return totalAmount ?? calculateOrderTotal({ amount: revenue, taxCost });
}
